import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles.css';
import './admin/admin.css';

createRoot(document.getElementById('root')).render(<App />);
